// EFRIX Documentation Navigation Configuration

export const navigation = [
  {
    title: 'Getting Started',
    links: [
      { title: 'Introduction', href: '/docs' },
      { title: 'Product Overview', href: '/docs/product-overview' },
      { title: 'Architecture', href: '/docs/architecture' },
    ],
  },
  {
    title: 'Developer Guide',
    links: [
      { title: 'Integration Guide', href: '/docs/developer-guide' },
      { title: 'SDK Documentation', href: '/docs/sdk-documentation' },
      { title: 'Interactive API Reference', href: '/efrix/api' },
    ],
  },
  {
    title: 'Reference',
    links: [
      { title: 'API Reference', href: '/docs/api-reference' },
      { title: 'Pricing', href: '/docs/pricing' },
      { title: 'URA Technical Brief', href: '/docs/ura-technical-brief' },
    ],
  },
]

// Flatten navigation for prev/next links
export function flattenNavigation() {
  return navigation.flatMap((section) => section.links)
}
